export default __webpack_public_path__ + "static/media/ic_text-strikethrough.447d341e.svg";